import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!) {
    deleteWebsite (input: { id: $id }) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/DeleteMutation.js